import React, { useState } from 'react'

import { AiOutlineQuestionCircle, AiOutlineBgColors } from 'react-icons/ai'
import { IoCloseCircleOutline } from 'react-icons/io5'
import { BiNotepad, BiHighlight, BiLeftArrowAlt } from 'react-icons/bi'

import { Container } from './styles'

interface ExcertToolsProps {
  left: number
  top: number
  selection: string
  openAnnotation(type): void
  setHighlight(string): void
  isHighlighted: boolean
}

const ExcertTools: React.FC<ExcertToolsProps> = ({
  left = 0,
  top = 0,
  selection = '',
  openAnnotation,
  setHighlight,
  isHighlighted = false,
}) => {
  const [openColorPicker, setOpenColorPicker] = useState<boolean>(false)

  const colorPicker = ['highlight-1', 'highlight-2', 'highlight-3', 'highlight-4']

  const disableSelect = (e) => {
    e.preventDefault()
    e.stopPropagation()
    return
  }

  const PickerComponent = () => (
    <>
      <button
        onPointerDown={disableSelect}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setOpenColorPicker(false)
        }}
      >
        <BiLeftArrowAlt size="24" />
      </button>
      {colorPicker.map((className, key) => (
        <button
          key={key}
          onPointerDown={disableSelect}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setHighlight(className)
          }}
        >
          <span className={className}></span>
        </button>
      ))}
    </>
  )

  const DoubtComponnent = () => (
    <button
      onClick={(e) => {
        e.preventDefault()
        openAnnotation('doubt')
      }}
    >
      <AiOutlineQuestionCircle /> Dúvida
    </button>
  )
  const NotesComponnent = () => (
    <button
      onClick={(e) => {
        e.preventDefault()
        openAnnotation('annotation')
      }}
    >
      <BiNotepad /> Anotar
    </button>
  )

  return (
    <Container top={top} left={left}>
      {openColorPicker && PickerComponent()}
      {!openColorPicker && !isHighlighted && (
        <>
          {NotesComponnent()}
          <button
            onPointerDown={disableSelect}
            onClick={(e) => {
              e.preventDefault()
              setOpenColorPicker(true)
            }}
          >
            <BiHighlight /> Marcar
          </button>
          <hr />
          {DoubtComponnent()}
        </>
      )}
      {!openColorPicker && isHighlighted && (
        <>
          <button
            onPointerDown={disableSelect}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setOpenColorPicker(true)
            }}
          >
            <AiOutlineBgColors /> Cor
          </button>
          <hr />
          <button
            onClick={(e) => {
              e.preventDefault()
              openAnnotation('annotation')
            }}
          >
            <BiNotepad /> Anotar
          </button>
          <hr />
          {DoubtComponnent()}
          <hr />
          <button
            onClick={(e) => {
              e.preventDefault()
              setHighlight('')
            }}
          >
            <IoCloseCircleOutline /> Descartar
          </button>
        </>
      )}
    </Container>
  )
}

export default ExcertTools
